export default {
    USER_SESSION:       "USER_LOCALSTORAGE_SESSION",
    WS_PANGGILAN:       "SOCKET_PANGGIL_ANTRIAN",
    WS_ANTRIAN_BARU:    "SOCKET_TAMBAH_ANTRIAN",
    WS_ANTRIAN_SELESAI: "SOCKET_ANTRIAN_SELESAI_DARI_LOKET"
}